module.exports = __webpack_public_path__ + "img/double-cover.c4f078ab.jpg";